module.exports = __webpack_public_path__ + "img/freeModeOff.93c1c890.svg";